import { Link, Location } from "react-router-dom";
import SideBarSubMenu from "./SidebarSubMenu";
import { useTranslation } from "react-i18next";
import { menuItemsDTO } from "./SidebarContentV2";
import { MisterIcon } from "@rtel/mister-icons";

import styles from "./SidebarMenuItem.module.css"


const getActiveClass = (currentPath: string, itemPath?: string): string => {
  const pathToCheck = itemPath || "";
  
  if (pathToCheck === "/") {
    return currentPath === "/" ? `${styles.active}` : "";
  }

  return currentPath.includes(pathToCheck) ? `${styles.active}` : "";
};


const SidebarMenuItem = ( {items, depthLevel, currentLocation}: SidebarMenuItemsProps ) => {
  const { t } = useTranslation();
  const activeClass = getActiveClass(currentLocation.pathname, items.path);

  return (
    <li>
      {items.submenu ? (
        <>
          <span className={styles.categoryHeader}>
          {items.icon && <MisterIcon name={items.icon} size="sm" className={styles.iconColorWhite} /> }
            <span>{t(items.title)}</span>
          </span>
      
          <ul className="sub-menu">
            <SideBarSubMenu submenus={items.submenu} depthLevel={depthLevel} currentLocation={currentLocation} />
         </ul>
        </>
      ) : (
        <Link 
          to={items.path ? items.path : ""} 
          className={activeClass} 
        >
          {items.icon && <MisterIcon name={items.icon} size="sm" className={styles.iconColorWhite} /> }
          <span>{t(items.title)}</span>
        </Link>
      )}
    </li>
  );
};

export default SidebarMenuItem;

interface SidebarMenuItemsProps {
  items: menuItemsDTO;
  depthLevel: number;
  currentLocation: Location;
}